import { render, staticRenderFns } from "./CommissionEditor.vue?vue&type=template&id=b3d5ea82&scoped=true"
import script from "./CommissionEditor.vue?vue&type=script&lang=js"
export * from "./CommissionEditor.vue?vue&type=script&lang=js"
import style0 from "./CommissionEditor.vue?vue&type=style&index=0&id=b3d5ea82&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d5ea82",
  null
  
)

export default component.exports